var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareemAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42337 7.51529V1.62672C7.42337 1.3584 7.23475 1.14282 7 1.14282C6.76525 1.14282 6.57527 1.3584 6.57527 1.62672V7.51529H1.42473C1.18997 7.51529 1 7.73243 1 7.99919C1 8.2675 1.18997 8.48464 1.42473 8.48464H6.57527V14.3732C6.57527 14.6415 6.76525 14.8571 7 14.8571C7.23475 14.8571 7.42337 14.6415 7.42337 14.3732V8.48464H12.5766C12.8114 8.48464 13 8.2675 13 7.99919C13 7.73243 12.8114 7.51529 12.5766 7.51529H7.42337Z",
    fill: "#111135",
    stroke: "#111135",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareemAddIcon);
export default __webpack_public_path__ + "static/media/careem-add-icon.275af608f6cffcfc7e19900adc9bb326.svg";
export { ForwardRef as ReactComponent };